import { Button, Col, Container, Row } from 'react-bootstrap'
import TableComponent from "../../../Table/Table";
import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import axios from "axios";
import "./PromoCode.css"
import toast from 'react-hot-toast';


export default function PromoCode() {
    const [searchParams] = useSearchParams();
    const AffiliateID = searchParams.get('id');

    const nav = useNavigate()
    const columns = React.useMemo(
        () => [
            {
                Header: 'Id',
                accessor: 'Id',
            },
            {
                Header: 'Site',
                accessor: 'Site',
            },
            {
                Header: 'Currency',
                accessor: 'Currency',
            },
            {
                Header: 'Promocode',
                accessor: 'Promocode',
            },
            {
                Header: "Btag",
                accessor: 'BTag',
            },
            {
                Header: 'Actions',
                accessor: 'actions',
                Cell: (props) => (
                    <span >
                        <Button disabled={deleteDisabled} onClick={() => Delete(props.row.original.Id)} size="sm" variant="danger">Delete</Button>
                    </span>
                ),
            },

        ],
        []
    );

    const [sites, setSites] = useState([]);
    const [campaigns, setCampaigns] = useState([]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchSite, setSearchSite] = useState("");
    const [deleteDisabled, setDeleteDisabled] = useState(false);
    const [form, setForm] = useState({
        website : "",
        campaign : "",
        currency : "usd",
        code : ""
    })

    const Back = () => {
        nav(-1)
    }

    const GetAllWebsites = async () => {
        const response = await axios.get(window.__CFG.API + "affiliates/GetAllWebsites/"+AffiliateID, {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        })

        if(response.data.Error == null) {
            setSites(response.data.Result)
        }
    }

    const GetAllCampaigns = async () => {
        const response = await axios.get(window.__CFG.API + "affiliates/GetAllCampaigns/"+AffiliateID, {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        })

        if(response.data.Error == null) {
            setCampaigns(response.data.Result);
        }
    }

    const GetAllPromocodes = async () => {
        setLoading(true);

        const response = await axios.get(window.__CFG.API + "affiliates/GetAllPromocodes/"+AffiliateID+"?site="+searchSite, {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        })

        setLoading(false);

        if(response.data.Error == null) {
            setData(response.data.Result);
        }
    }

    useEffect(() => {
        GetAllWebsites();
        GetAllCampaigns();
    }, [])

    useEffect(() => {
        GetAllPromocodes();
    }, [])

    const CreatePromocode = async () => {
        setLoading(true);
        const response = await axios.post(window.__CFG.API + "affiliates/CreatePromocode/"+AffiliateID, form, {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        })
        setLoading(false);

        if(response.data.Error == null) {
            GetAllPromocodes();

            toast.success("Promocode generated", {
                duration: 4000
            })
        } else {
            toast.error(response.data.Error, {
                duration: 4000
            })
        }
    }

    const Delete = async (id) => {
        setDeleteDisabled(true);
        const response = await axios.post(window.__CFG.API + "affiliates/DeletePromocode/"+AffiliateID, {
            id : id
        }, {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        })
        setDeleteDisabled(false);
        if(response.data.Error == null) {
            toast.success("Promocode deleted", {
                duration: 4000
            })
            GetAllPromocodes();
        } else {
            toast.error(response.data.Error, {
                duration: 4000
            })
        }
    }

    return (
        <>
            <div className='aff-menu'>
                <div className="aff-row-menu">
                    <div className='aff-row'>
                        <div className="aff-col">
                            <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp aff-menu-btn"
                                onClick={() => Back()}
                            >
                                Back
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="promo-form-wp">
                <div className="promo-form">
                    <div className="promo-lbl">
                        Site
                    </div>
                    <div className="promo-in">

                        <select onChange={e => setForm({...form, website : e.target.value})} style={{ padding: 5, width: "100%" }} >
                            <option>Website</option>
                            {
                                sites.map(site => {
                                    return (
                                        <option value={site.value}>{site.label}</option>
                                    )
                                })
                            }
                        </select>
                    </div>
                </div>
                <div className="promo-form">
                    <div className="promo-lbl">
                        Currency
                    </div>
                    <div className="promo-in">
                        <select style={{ width: "100%", padding: 5 }} >
                            <option>USD</option>
                        </select>
                    </div>
                </div>
                <div className="promo-form">
                    <div className="promo-lbl">
                        Campaign
                    </div>
                    <div className="promo-in">
                        <select onChange={e => setForm({...form, campaign : e.target.value})} style={{ width: "100%", padding: 5 }} >
                            <option>Campaign</option>
                            {
                                campaigns.map(campaign => {
                                    return (
                                        <option value={campaign.value}>{campaign.label}</option>
                                    )
                                })
                            }
                        </select>
                    </div>
                </div>
                <div className="promo-form">
                    <div className="promo-lbl">
                        promo code
                    </div>
                    <div className="promo-in">
                        <input onChange={e => setForm({...form, code : e.target.value})} type="text" style={{ width: "100%", padding: 3 }} />
                    </div>
                </div>
                <div className="promo-form">
                    <div className="promo-lbl">
                    </div>
                    <div className="promo-in">
                        <Button onClick={CreatePromocode} disabled={loading} className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp "
                        >
                            Create promo code
                        </Button>
                    </div>
                </div>
            </div>
            <div className='aff-grp-section-table-title'>
                Promocodes
            </div>
            <div className='promo-filter'>
                <div className='pomo-filter-col'>
                    <div className='promo-filter-col-lbl'>
                        Sites
                    </div>
                    <div className='promo-filter-col-in'>
                        <select onChange={e => setSearchSite(e.target.value)} style={{ width: "100%", padding: 5 }} >
                            <option value="">All Sites</option>
                            {
                                sites.map(site => {
                                    return (
                                        <option value={site.value}>{site.label}</option>
                                    )
                                })
                            }
                        </select>
                    </div>
                </div>
                <div className='pomo-filter-col'>
                    <Button onClick={() => GetAllPromocodes(searchSite)} className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp "
                    >
                        Search
                    </Button>
                </div>
            </div>
            <div className='aff-grp-section-table'>
                <div className="aff-dash-summary-table">
                    <TableComponent loading={loading} columns={columns} data={data} hiddenPagination={true} />
                </div>
            </div>
        </>
    )
}